/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-async-promise-executor */
// NOTE: 'syncAnimals' is for storing offline submitted pending animals to sync with back end when get online
// but 'animals' is for storing an offline list of animals to show when offline
import connector from '../connector';
import userPermissions from './userPermissions';

const addAnimal = (animal) => new Promise(async (resolve, reject) => {
    try {
        const userId = localStorage.getItem('userId');
        if (userId) {
            const db = await connector();
            const transaction = db.transaction('syncAnimals', 'readwrite');
            const syncAnimalsStore = transaction.objectStore('syncAnimals');

            const offlineId = Date.now();
            const animalToSave = {
                userId,
                offlineId,
                ...animal
            }

            const checkPermission = await userPermissions.checkHasPermission(animalToSave?.farmId, 'write_animal');
            if (checkPermission?.success && checkPermission?.permission) {
                syncAnimalsStore.add(animalToSave);
                transaction.oncomplete = () => {
                    db.close();
                    resolve({ success: true, offlineId });
                };
            }
            else {
                reject({ success: false, code: 403, error: 'Error: Permission denied!', });
            }
        }
        else {
            reject({ success: false, error: 'Error: User not found!' });
        }
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getAnimalsList = () => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('syncAnimals', 'readonly');
        const syncAnimalsStore = transaction.objectStore('syncAnimals');

        const allAnimals = syncAnimalsStore.getAll();

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: allAnimals.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getAnimalByOfflineId = (offlineId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('syncAnimals', 'readonly');
        const syncAnimalsStore = transaction.objectStore('syncAnimals');

        const animal = syncAnimalsStore.get(offlineId);

        transaction.oncomplete = () => {
            db.close();
            if (animal && animal.result) {
                resolve({ success: true, animal: animal.result });
            }
            else {
                reject({ success: false, error: 404 });
            }
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const deleteAnimal = (offlineId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('syncAnimals', 'readwrite');
        const syncAnimalsStore = transaction.objectStore('syncAnimals');

        syncAnimalsStore.delete(offlineId);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});


const syncAnimals = {
    addAnimal,
    getAnimalsList,
    getAnimalByOfflineId,
    deleteAnimal
}

export default syncAnimals;
